import { CONVERSATION_CONTACT_FRIENDS_WITH_PRESENCE } from '@/config/api/api-routes';
import { http } from '@/shared/api/http';
import type { FriendsWithPresenceRes } from '../models/friend-presence-dto';

export const getFriendsWithPresence = async () => {
  try {
    const response = await http.get<FriendsWithPresenceRes>(CONVERSATION_CONTACT_FRIENDS_WITH_PRESENCE);
    return response.data.data.friends;
  } catch (error) {
    console.error('[FriendPresenceService] API call failed:', error);
  }
};
